import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import { useTranslation } from "react-i18next";

export default function DashboardCachesButton({ visible, onOpen }) {
  const { t } = useTranslation("settings");

  if (!visible) return null;

  const title = t("dashboardCaches.buttonTitle", {
    defaultValue: "Relatórios em cache",
  });

  return (
    <Tooltip title={title}>
      <IconButton
        size="small"
        onClick={onOpen}
        aria-label={title}
        sx={{
          border: 1,
          borderColor: "divider",
          borderRadius: 1.5,
          width: 36,
          height: 36,
        }}
      >
        <StorageOutlinedIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Tooltip>
  );
}
